import React from "react";

const AdminTablesComponent = props => {

    return(
   <>
       AdminTablesComponent
    </>
    );
}

AdminTablesComponent.defaultProps = {

}
AdminTablesComponent.propTypes = {

}

export default (AdminTablesComponent);